var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BjAlert", {
    ref: "alert",
    staticClass: "bottom transition-box",
    attrs: { title: "", "show-icon": false, center: "" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }